// src/components/assistant/DeleteConfirmationModal.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function DeleteConfirmationModal({ show, onHide, onConfirm, assistant, loading, t }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton style={{ borderBottom: '2px solid #f0f0f0' }}>
        <Modal.Title>
          ⚠️ {t?.confirmDelete || 'Confirm Deletion'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '24px' }}>
        <p>{t?.deleteMessage || 'Are you sure you want to delete this assistant?'}</p>
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span style={{ fontSize: '1.5rem' }}>🤖</span>
          <strong>{assistant?.name}</strong>
        </div>
        <p style={{ color: '#dc3545', fontSize: '0.9rem', marginBottom: 0 }}>
          ⚠️ {t?.warningMessage || 'This action cannot be undone. All configuration will be permanently lost.'}
        </p>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: '2px solid #f0f0f0' }}>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          {t?.cancel || 'Cancel'}
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? '⏳' : '🗑️'} {t?.yesDelete || 'Yes, Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
